var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 10L3.22222 8M3.22222 8L11 1L18.7778 8M3.22222 8V18C3.22222 18.2652 3.33929 18.5196 3.54766 18.7071C3.75603 18.8946 4.03865 19 4.33333 19H7.66667M18.7778 8L21 10M18.7778 8V18C18.7778 18.2652 18.6607 18.5196 18.4523 18.7071C18.244 18.8946 17.9614 19 17.6667 19H14.3333M7.66667 19C7.96135 19 8.24397 18.8946 8.45234 18.7071C8.66071 18.5196 8.77778 18.2652 8.77778 18V14C8.77778 13.7348 8.89484 13.4804 9.10322 13.2929C9.31159 13.1054 9.5942 13 9.88889 13H12.1111C12.4058 13 12.6884 13.1054 12.8968 13.2929C13.1052 13.4804 13.2222 13.7348 13.2222 14V18C13.2222 18.2652 13.3393 18.5196 13.5477 18.7071C13.756 18.8946 14.0386 19 14.3333 19M7.66667 19H14.3333",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHome);
export default __webpack_public_path__ + "static/media/ico_home.df51f2ded59a5ee129532f42a8bcca6f.svg";
export { ForwardRef as ReactComponent };